import {
  GET_OTHER_BENEFITS_START,
  GET_OTHER_BENEFITS_SUCCESS,
  GET_OTHER_BENEFITS_ERROR,
  POST_OTHER_BENEFITS_START,
  POST_OTHER_BENEFITS_SUCCESS,
  POST_OTHER_BENEFITS_ERROR,
  SELECT_PLAN,
  TOGGLE_SHOW_MORE_OTHER,
} from "../actions/otherBenefitsActions";

const initialState = {
  data: null,
  isFetching: false,
  error: null,
};

const formatBenefit = benefit => {
  return {
    ...benefit,
    showMore: true,
    members: benefit.members.map(member => {
      return {
        ...member,
        plans: member.plans.map(plan => {
          return { ...plan, isSelected: plan.isDefault };
        }),
      };
    }),
  };
};

const initOtherBenefits = data => {
  return data.map(acc => {
    return {
      ...acc,
      otherBenefits: acc.otherBenefits.map(formatBenefit),
    };
  });
};

const updateAccountBenefits = (account, selectedPlan) => {
  return account.otherBenefits.map(benefit => {
    if (benefit.id === selectedPlan.benefitId) {
      return {
        ...benefit,
        members: benefit.members.map(member => {
          if (member.memberKey === selectedPlan.memberKey) {
            return {
              ...member,
              plans: member.plans.map(plan => {
                return { ...plan, isSelected: plan.id == selectedPlan.plan.id };
              }),
            };
          } else {
            return {
              ...member,
            };
          }
        }),
      };
    } else {
      return {
        ...benefit,
      };
    }
  });
};

const getUpdateOtherBenefits = (data, selectedPlan) => {
  return data.map(acc => {
    if (acc.accountId === selectedPlan.accountId) {
      return {
        ...acc,
        otherBenefits: updateAccountBenefits(acc, selectedPlan),
      };
    } else {
      return {
        ...acc,
      };
    }
  });
};

const toggleShowMore = (data, panel) => {
  return data.map(acc => {
    if (acc.accountId === panel.accountId) {
      return {
        ...acc,
        otherBenefits: acc.otherBenefits.map(benefit => {
          if (benefit.id === panel.benefitId) {
            return {
              ...benefit,
              showMore: !benefit.showMore,
            };
          } else {
            return {
              ...benefit,
            };
          }
        }),
      };
    } else {
      return {
        ...acc,
      };
    }
  });
};
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_OTHER_BENEFITS_START:
    case POST_OTHER_BENEFITS_START:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case GET_OTHER_BENEFITS_SUCCESS:
      return {
        ...state,
        data: initOtherBenefits(action.payload),
        isFetching: false,
      };
    case GET_OTHER_BENEFITS_ERROR:
    case POST_OTHER_BENEFITS_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    case POST_OTHER_BENEFITS_SUCCESS:
      return {
        ...initialState,
      };
    case SELECT_PLAN:
      return {
        ...state,
        data: getUpdateOtherBenefits(state.data, action.payload),
        isFetching: false,
      };
    case TOGGLE_SHOW_MORE_OTHER:
      return {
        ...state,
        data: toggleShowMore(state.data, action.payload),
        isFetching: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/otherBenefitsReducer.js